
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/defi",
      function () {
        return require("private-next-pages/solutions/defi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/defi"])
      });
    }
  